import React, { useEffect, useState } from 'react';
import { useAddProject, useFetchProjects, useUpdateProject } from '../../hooks/api/projects/projects';
import { useAddSurvey, useFetchSurvey } from '../../hooks/api/survey/survey';
import { toast } from 'react-toastify';
import { useFetchOrganizations } from '../../hooks/api/organisation/organisation';

const projectsData = [
  { id: 1, name: 'Project Alpha', organization: 'Acme Corp', description: 'Developing a new mobile app' },
  { id: 2, name: 'Project Beta', organization: 'Beta Industries', description: 'Website redesign' },
  { id: 3, name: 'Project Gamma', organization: 'Gamma Solutions', description: 'Building a data pipeline' },
];


const SurveyManagement = () => {
const [filters, setFilters]=useState({
    orgId:"",
    search:"",
    pageNumber:1,
    pageSize:10000
})

const fetchProjectsAPI= useFetchProjects(filters)

    const fetchSurveyAPI= useFetchSurvey(filters)
   const fetchOrganisationAPI= useFetchOrganizations()
    const [organizations, setOrganizations] =useState( []);
  const [projects, setProjects] = useState(projectsData);
  const [newProject, setNewProject] = useState({ name: '', organization: '', description: '' });
  const [editProject, setEditProject] = useState(null);

  const addSurveyAPI= useAddSurvey()
  const updateProjectAPI= useUpdateProject()

  const handleInputChange = (e) => {
    setNewProject({ ...newProject, [e.target.name]: e.target.value });
  };


  const handleAddProject = () => {
  
  toast.dismiss()
  toast.loading(`Adding Survey`)
    addSurveyAPI.mutate({
        "name": newProject.name,
        // "description": newProject.description,
        "projectId": newProject.projectId
      },
        {
            onSuccess(addProjectResponse){
toast.dismiss()
toast.success(`Survey Added Successfully`)
                setProjects([...projects, { id: addProjectResponse?.project?.id, ...newProject }]);
            }, 
            onError: (error) => {
                console.log({error})
                toast.dismiss()
                toast.error(   `Unable to add Projects`)
            }

        }
    )
    setNewProject({ name: '', organization: '', description: '' });
  };

  const handleDeleteProject = (id) => {
    setProjects(projects.filter((project) => project.id !== id));
  };

  const handleEditProject = (project) => {
    

    setEditProject({ ...project });
  };

  const handleUpdateProject = () => {
  
    toast.dismiss()
  toast.loading(`Adding Project`)
    updateProjectAPI.mutate({
        "name": editProject.name,
        "description": editProject.description,
        "orgId": editProject.organization,
        id:editProject.id ,
      },
        {
            onSuccess(addProjectResponse){
toast.dismiss()
toast.success(`Project Added Successfully`)
setProjects(
    projects.map((project) => (project.id === editProject.id ? { ...project, ...editProject } : project))
  );    }, 
            onError: (error) => {
                console.log({error})
                toast.dismiss()
                toast.error(   `Unable to add Projects`)
            }

        }
    )
  
   
    setEditProject(null);
  };


    // useEffect(()=>{
    //   if(fetchOrganisationAPI.data){
  
    //       setOrganizations(fetchOrganisationAPI.data?.orgs)
    //   }
    // }, [fetchOrganisationAPI.data])

useEffect(()=>{
if(fetchProjectsAPI.data){
    setProjects(fetchProjectsAPI.data?.projects)
}
}, [fetchProjectsAPI.data])

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Survey Management</h1>

      {/* Add Project Form */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-4">
        <h2 className="text-xl font-semibold mb-2">Add New Survey</h2>
        <div className="grid grid-cols-2 gap-4"> {/* Adjusted grid for description */}
          <input
            type="text"
            name="name"
            placeholder="Survey Name"
            value={newProject.name}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          />
          <select
            name="projectId"
            // value={newProject.organization}
            onChange={handleInputChange}
            className="border rounded px-3 py-2"
            required
          >
            <option value="">Select Project</option>
            {projects.map((org) => (
              <option key={org?.id} value={org?.id}>
                {org?.name}
              </option>
            ))}
          </select>
          {/* <textarea  // Use textarea for description
            name="description"
            placeholder="Description"
            value={newProject.description}
            onChange={handleInputChange}
            className="border rounded px-3 py-2 col-span-2" // Span across two columns
            required
          /> */}
        </div>
        <button
          onClick={handleAddProject}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Add Survey
        </button>
      </div>

      {/* Project Table */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-2">Project List</h2>
      
     {/* Select active organisation */}
     <select
              name="organization"
            //   value={editProject.organization}
              onChange={(e) => setFilters(prev=>({ ...prev, projectId: e.target.value }))}
              className="border rounded px-3 py-2 mb-2"
              required
            >
              <option value="">Select Project</option>
              {fetchProjectsAPI.data?.projects?.map((org) => (
                <option key={org?.id} value={org?.id}>
                  {org?.name}
                </option>
              ))}
            </select>

        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className='text-left'>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">Projects</th>
              {/* <th className="px-4 py-2">Description</th> */}
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {fetchSurveyAPI.data?.surveyTypes?.map((project) => (
              <tr key={project.id}>
                <td className="px-4 py-2">{project.name}</td>
                <td className="px-4 py-2">
                {projects?.find(org => org.id === project.projectId)?.name|| "N/A"}
             
                  </td>
                {/* <td className="px-4 py-2">{project.description}</td> */}
                <td className="px-4 py-2 flex gap-2">
                  <button
                    onClick={() => handleEditProject(project)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteProject(project.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit Project Form (Conditional Rendering) */}
      {editProject && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold mb-2">Edit Project</h2>
            <input
              type="text"
              name="name"
              value={editProject.name}
              onChange={(e) => setEditProject({ ...editProject, name: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
              required
            />
            <select
              name="organization"
              value={editProject.organization}
              onChange={(e) => setEditProject({ ...editProject, organization: e.target.value })}
              className="border rounded px-3 py-2 mb-2"
              required
            >
              <option value="">Select Organization</option>
              {organizations?.map((org) => (
                <option key={org?.id} value={org?.id}>
                  {org?.name}
                </option>
              ))}
            </select>
            <textarea
              name="description"
              value={editProject.description}
              onChange={(e) => setEditProject({ ...editProject, description: e.target.value })}
              className="border rounded px-3 py-2 mb-2 w-full"  // Added width for better layout
              required
            />
            <button
              onClick={handleUpdateProject}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
            >
              Update
            </button>
            <button
              onClick={() => setEditProject(null)}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveyManagement;